<template>
    <div class="wp">
        <div class="w-1200 company-center-1">
            <div class="left">
                <div class="item" style="height:130px;">
                    <!-- <i class="el-icon-arrow-right arrow"></i> -->
                    <p  class="p1">按地区分类</p>
                    <p v-for="(item,index) in rType" :key="index" class="p2 pointer " :class="{active:currentType==1&&item.id==currentId}"  @click="clickType('1',item.id)">{{item.name}}</p>
                </div>
                <div class="item" style="height:300px;">
                    <!-- <i class="el-icon-arrow-right arrow"></i> -->
                    <p class="p1">按经营模式</p>
                    <p v-for="(item,index) in cType" :key="index" class="p2 pointer " :class="{active:currentType==2&&item.code==currentId}" @click="clickType('2',item.code)">{{item.name}}</p>
                </div>
            </div>
            <div class="right">
                <el-carousel indicator-position="none" height="500px">
                        <el-carousel-item v-for="(item,index) in imgs" :key="index" @click.native="getDetail(item.id)">
                             <el-image style="width: 100%; height: 100%" :src="item.pics" fit="contain">
                             <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                    </div> -->
                            </el-image>
                            <p class="img-title">{{item.companyname}}</p>
                        </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div v-for="(item,index) in companys" :key="index" class="w-1200 company-center-2">
           <div class="title-more">
                <div class="t-m-blue"></div>
                    <p class="t-m-t" style="width:200px;">{{item.companytype}}</p>
                </div>
            <div class="b-b">
                <el-row :gutter="10"> 
                    <el-col v-for="(item2,index2) in item.tldRtnDtos" :key="index2" class="m-t-20" :span="8">
                       <div class="b-b-i pointer" @click="getDetail(item2.id)">
                            <div class="img">
                                <!-- <img :src="item2.pics"> -->
                                <el-image style="width: 100%; height: 100%" :src="item2.pics" fit="contain">
                                    <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                            <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                            </div> -->
                                </el-image>
                            </div>
                            <div class="right">
                                <p class="p1">{{item2.companyname}}</p>
                                <p class="p2" style="height:30px;">主营</p>
                                <p class="p3" style="height:30px;">{{item2.cp}}</p>
                                <p class="p2" style="height:30px;">电话</p>
                                <p class="p3" style="height:30px;">{{item2.lxdh}}</p>
                            </div>
                            
                        </div>
                    </el-col>
                   
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
import CompanyCenter from './CompanyCenter.js';
export default CompanyCenter;
</script>
<style lang="scss" scoped>
@import './CompanyCenter.scss';
</style>